export default __webpack_public_path__ + "static/media/151-mailed.9c3f329f.png";